import { z } from "zod";

// zod compiles object parsers with `new Function` when it can, and probes for
// that by trying one. The SPA's Content-Security-Policy has no 'unsafe-eval',
// so the probe would only ever fail and file a CSP violation report on every
// load. Imported first from main.tsx: zod decides when a schema is defined,
// and @rivets/core defines its schemas as it loads.
z.config({ jitless: true });
